export default __webpack_public_path__ + "static/media/icon-check.6a387e3c.svg";